import { useRouter } from "next/router";
import { logError } from "repoV2/utils/common/error/error";
import useToastMessage from "repoV2/components/common/Toast/useToastMessage";
import { setSessionStorageItem } from "repoV2/utils/common/storage/getterAndSetters";
import { SESSION_STORAGE_KEYS } from "repoV2/constants/common/storage/sessionStorage";
import { constructRoute } from "repoV2/utils/urls&routing/routing";
import { APP_ROUTE_KEYS } from "repoV2/constants/urls&routing/routing";
import { generateExpressInterestPayload } from "./generateExpressInterestPayload";
import { callPostExpressInterestApi } from "./api/CreateExpressInterestApi/CreateExpressInterestApi";
import { ICreateExpressInterest } from "../interfaces/ExpressInterest.interfaces";

const useSubmitExpressInterest = () => {
    const router = useRouter();
    const { notify, toast_type_keys } = useToastMessage();

    const submitExpressInterest = async (data: ICreateExpressInterest) => {
        const {
            expressInterestFormValues,
            hostName,
            listingUuid,
            logType,
            dynamicLinkUuid,
            isSoldOut,
            postInterestUrl,
            unprocessedLeadsQuestionAndAnswer,
        } = data;
        const expressInterestPayload = generateExpressInterestPayload({
            expressInterestFormValues,
            hostName,
            listingUuid,
            logType,
            dynamicLinkUuid,
        });

        try {
            await callPostExpressInterestApi(expressInterestPayload);
            if (!isSoldOut) {
                notify("Your message has been successfully sent.", {
                    type: toast_type_keys.success,
                });
            } else if (isSoldOut) {
                // If the listing is of type sold out, we redirect the user to than you page
                setSessionStorageItem(
                    SESSION_STORAGE_KEYS.EXPRESS_INTEREST_FORM_DATA,
                    JSON.stringify({
                        ...expressInterestPayload,
                        unprocessed_lead_answers:
                            unprocessedLeadsQuestionAndAnswer,
                    })
                );
                router.push(
                    constructRoute({
                        appRouteKey: APP_ROUTE_KEYS.THANKYOU_OPTIN,
                        args: {
                            slug: listingUuid,
                        },
                    })
                );
            }
            // If we have a postBookingUrl, we redirect the user to this url
            if (postInterestUrl) {
                window.open(postInterestUrl, "_blank");
            }
        } catch (err) {
            notify("Something went wrong! Try again?", {
                type: toast_type_keys.error,
            });
            logError({
                error: err,
                occuredAt:
                    "createExpressInterest in repoV2/features/ExpressInterest/utils/createExpressInterest.ts",
                when: "create express interest api call",
            });
        }
    };

    return {
        submitExpressInterest,
    };
};

export default useSubmitExpressInterest;
